import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextInputComponent } from './text-input.component';
import { InputContainerModule } from '../input-container/input-container.module';

@NgModule({
  declarations: [TextInputComponent],
  imports: [CommonModule, InputContainerModule],
  exports: [InputContainerModule, TextInputComponent],
})
export class TextInputModule {}
